import React from 'react';
import CookieConsent from 'react-cookie-consent';

const CookieConsentBar = () => {
  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept"
      cookieName="site-cookie-consent"
      style={{
        background: 'rgb(6 11 35 / 1)',
        boxShadow: '0 -12px 24px -6px rgb(0 0 0 / 0.5), 0 -6px 12px -6px rgb(0 0 0 / 0.5)',
        color: 'rgba(255, 255, 255, 0.7)'
      }}
      buttonStyle={{
        background: 'rgb(0, 171, 200)',
        color: 'rgba(255, 255, 255, 0.7)',
        fontSize: '13px'
      }}
      expires={365}
      onAccept={() => {
        // Just close the cookie bar
      }}
    >
      This website uses cookies to enhance your experience. By continuing to use this site, you
      consent to our use of cookies.{' '}
      <a
        href="/cookie-policy"
        style={{
          textDecoration: 'underline',
          color: 'rgb(0, 171, 200)'
        }}
      >
        Cookie Policy
      </a>
    </CookieConsent>
  );
};

export default CookieConsentBar;
